export default "__VITE_ASSET__dfbebadc__"